import * as React from 'react';
import * as classNames from 'classnames';
import Paper, {PaperProps} from '@material-ui/core/Paper/Paper';
import {withStyles, WithStyles, createStyles} from '@material-ui/core/styles';
import {Theme, MuiThemeProvider} from '@material-ui/core/styles';
import {createDarkMuiTheme} from 'cl-layout/ThemeHelpers';
import {selectedCount} from 'cl-table/redux/actions';
import Typography, {TypographyProps} from '@material-ui/core/Typography';
import withTable from 'cl-table/redux/withTable';
import {TableState} from 'cl-table/redux/actions';
type TableStateProps = 'selection' | 'count';

export interface ActionsPanelProps extends Pick<TableState, TableStateProps> {
  sticky?: boolean;
  actions?: {
    left?: React.ReactElement<any>;
    right?: React.ReactElement<any>;
    selectedLeft?: React.ReactElement<any>;
    selectedRight?: React.ReactElement<any>;
  };
  text?: string;
}

class ActionsPanel extends React.PureComponent<ActionsPanelProps & WithStyles<typeof styles> & PaperProps> {
  render() {
    const {
      count,
      selection,
      text,
      actions: {left, right, selectedLeft, selectedRight},
      classes: {actions, selectedActions, selectionInfo, leftSelectionActions, sticky: stickyClass},
      className,
      sticky,
    } = this.props;
    const countSelected = count && selection ? selectedCount({count, selection}) : undefined;
    let panelActions =
      left || right || (countSelected && (selectedLeft || selectedRight)) ? (
        <Paper
          className={classNames(actions, {
            [stickyClass]: sticky,
            [className]: !countSelected,
            [selectedActions]: !!countSelected,
          })}
        >
          {countSelected ? (
            <React.Fragment>
              <SelectionInfo count={count} selectedCount={countSelected} className={selectionInfo} />
              <div className={leftSelectionActions}>{selectedLeft}</div>
              <div>{selectedRight}</div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div>{left}</div>
              {right ? (
                <div>
                  {text}
                  {right}
                </div>
              ) : (
                undefined
              )}
            </React.Fragment>
          )}
        </Paper>
      ) : (
        undefined
      );
    if (countSelected && panelActions) {
      panelActions = <MuiThemeProvider theme={createDarkMuiTheme()}>{panelActions}</MuiThemeProvider>;
    }
    return panelActions ? panelActions : <React.Fragment />;
  }
}

const styles = (theme: Theme) =>
  createStyles({
    actions: {
      height: theme.spacing(8),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    selectedActions: {
      justifyContent: 'flex-start',
      backgroundColor: theme.palette.primary.main,
    },
    leftSelectionActions: {
      position: 'relative',
      marginLeft: theme.spacing(1),
      marginRight: 'auto',
      '&::before': {
        position: 'absolute',
        content: '""',
        width: 1,
        height: `calc(100% - ${theme.spacing(1.5)}px)`,
        top: theme.spacing(3) / 4,
        left: 0,
        borderLeft: `1px solid ${theme.palette.primary.contrastText}`,
      },
    },
    selectionInfo: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    sticky: {
      left: 0,
      position: 'sticky',
      marginBottom: theme.spacing(2),
    },
  });
export default withTable<TableStateProps>({props: ['count', 'selection']})(withStyles(styles)(ActionsPanel));

interface SelectionInfoProps {
  selectedCount: number;
  count: number;
}

const SelectionInfo: React.SFC<SelectionInfoProps & TypographyProps> = ({count, selectedCount, ...props}) => (
  <Typography variant="body2" {...props}>
    {count === selectedCount ? 'All ' : undefined}
    {selectedCount} selected
  </Typography>
);
